module.exports = __webpack_public_path__ + "media/images/pc/top/icon-station_white-09f562bfaef2fe362ca92804d0738ad9.svg";